export const ITEM_PLAN_INVENTORY_MAPPING_CREATE = 'character.ITEM_PLAN_INVENTORY_MAPPING_CREATE';
